document.addEventListener('click', (e) => {
	const link = e.target.closest('.f-mobile-nav__item--has-child > .f-mobile-nav__link')
	if (!link) return
	e.preventDefault()
	const li = link.closest('.f-mobile-nav__item--has-child')
	const tab = li && li.querySelector(':scope > collapsible-tab')
	if (tab) tab.toggle()
})

class MobileNavToggle extends HTMLElement {
	constructor() {
		super()
		this.menuDrawer = document.querySelector('.f-drawer-mobile-nav')
		this.addEventListener('click', this.openNav.bind(this))

		if (this.menuDrawer) {
			this.menuDrawer.addEventListener('close', () => {
				this.setAttribute('aria-expanded', 'false')
			})
		}
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.openNav.bind(this))
	}

	openNav() {
		if (this.menuDrawer) {
			this.menuDrawer.openDrawer()
			this.setAttribute('aria-expanded', 'true')
		}
	}
}
customElements.define('mobile-nav-toggle', MobileNavToggle)
